import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "props-spinner-container"
};
const _hoisted_2 = {
  class: "prop-name"
};
const _hoisted_3 = {
  class: "lottery-container"
};
import { ref, computed, onMounted } from 'vue';
import 'element-plus/es/components/icon/style/css';
import gsap from 'gsap';
import { ElMessage, ElOption, ElSelect } from 'element-plus';
import store from '@/store';
import { request } from '@/manager/net_manager';
import { isUserType } from '@/tools/utils';
export default {
  __name: 'PropsSpinner',
  props: {
    ceremony: {
      type: Object,
      required: true
    }
  },
  emits: ['updateRecord'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const message = ref(null);
    const isSpinning = ref(false);
    const currentRotation = ref(0);
    const targetIndex = ref(0);
    const role = ref(null);
    const chances = ref(0); // computed

    const roleArray = computed(() => store.state.role_array ?? []);
    const userType = computed(() => {
      return store.state.user ? parseInt(store.state.user.user_type) : 4;
    });
    const wheelStyle = computed(() => ({
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '200%',
      transform: 'translateY(505%) translateX(0rem)',
      backgroundColor: 'rgba(0, 0, 0, 0.2)'
    })); // functions

    const getCardStyle = index => {
      const angle = 360 / props.ceremony.props.length;
      const offset = angle * index;
      return {
        position: 'absolute',
        width: '100%',
        height: '550%',
        transform: `rotate(${offset + currentRotation.value}deg) translateY(-50%)`,
        display: 'flex',
        // backgroundColor: 'rgba(20, 0, 0, 0.8)',
        alignItems: 'flex-start',
        justifyContent: 'center'
      };
    };

    const startAnimation = stopIndex => {
      if (isSpinning.value) return; // console.log(`stopIndex = ${stopIndex}`)

      isSpinning.value = true;
      const fullRotations = Math.floor(Math.random() * 3) + 2; // const fullRotations = 0

      const segmentAngle = 360 / props.ceremony.props.length; // 计算当前旋转角度下，目标卡片需要旋转到的位置
      // 为了让目标卡片停在顶端，我们需要计算从当前位置到目标位置的精确角度
      // 计算需要旋转的角度，确保顺时针旋转

      let rotationToTarget = (-stopIndex * segmentAngle - currentRotation.value) % 360;

      if (rotationToTarget < 0) {
        rotationToTarget += 360;
      } // 添加完整的旋转圈数


      const totalRotation = currentRotation.value + fullRotations * 360 + rotationToTarget;
      targetIndex.value = stopIndex; // 使用gsap实现更流畅的先快后慢旋转效果

      gsap.to(currentRotation, {
        value: totalRotation,
        duration: 5,
        ease: 'power3.out',
        onComplete: () => {
          // 确保最终旋转角度精确
          currentRotation.value = totalRotation;
          isSpinning.value = false;
        }
      });
    };

    const roleChanged = () => {
      if (message.value) {
        message.value.close();
      }

      let parameters = {
        'ceremony_id': props.ceremony.id,
        'role_id': role.value
      };
      request('ceremony/chances/get/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        chances.value = response.data;
      });
    };

    const submitLottery = () => {
      if (isSpinning.value) return;

      if (message.value) {
        message.value.close();
      }

      if (!isUserType(userType.value)) {
        message.value = ElMessage.error({
          message: '仅链接者允许参与庆典',
          duration: 1500
        });
        return;
      }

      if (!role.value) {
        message.value = ElMessage.error({
          message: '需要一个参与角色',
          duration: 1500
        });
        return;
      }

      if (chances.value <= 0) {
        message.value = ElMessage.error({
          message: '参与次数耗尽',
          duration: 1500
        });
        return;
      }

      let parameters = {
        'ceremony_id': props.ceremony.id,
        'role_id': role.value
      };
      request('ceremony/lottery/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          startAnimation(response.data.index);
          chances.value = response.data.chances;
          setTimeout(() => {
            emits('updateRecord', response.data.prop);
          }, 5 * 1000);
        }
      });
    };

    onMounted(() => {
      if (roleArray.value.length === 0 && isUserType(userType.value)) {
        store.dispatch('get_roles');
      }
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");

      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        style: _normalizeStyle(wheelStyle.value)
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.ceremony.props, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          style: _normalizeStyle(getCardStyle(index))
        }, [_createElementVNode("div", {
          class: _normalizeClass(["prop-content-view", [`rare-${item.rare_level}`, index === targetIndex.value && !isSpinning.value ? 'selected' : '']])
        }, [_createVNode(_component_el_image, {
          class: "prop-image",
          src: item.image,
          draggable: "false"
        }, null, 8, ["src"]), _createElementVNode("text", _hoisted_2, _toDisplayString(item.name), 1)], 2)], 4);
      }), 128))], 4), _createElementVNode("div", _hoisted_3, [_createVNode(_unref(ElSelect), {
        modelValue: role.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => role.value = $event),
        placeholder: "选择角色",
        "no-data-text": "无数据",
        onChange: roleChanged
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleArray.value, (item, index) => {
          return _openBlock(), _createBlock(_unref(ElOption), {
            key: index,
            label: item['nickname'],
            value: item['id']
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_button, {
        onClick: submitLottery,
        disabled: chances.value <= 0
      }, {
        default: _withCtx(() => [_createTextVNode(" 抽取奖励 (" + _toDisplayString(chances.value) + ") ", 1)]),
        _: 1
      }, 8, ["disabled"])])]);
    };
  }

};